"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _moment = _interopRequireDefault(require("moment"));

var _vuedraggable = _interopRequireDefault(require("vuedraggable"));

var _lastMileDelivery = require("@/mixins/last-mile-delivery/last-mile-delivery");

var _mapChina = _interopRequireDefault(require("@/components/map-china/map-china.vue"));

var _mapWorld = _interopRequireDefault(require("@/components/map-world/map-world.vue"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDTransferOrderModalComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDTransferOrderModalComponent, _Mixins);

  var _super = _createSuper(LMDTransferOrderModalComponent);

  function LMDTransferOrderModalComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDTransferOrderModalComponent);
    _this = _super.apply(this, arguments);
    _this.openMapModal = false;
    _this.mapPoints = [];
    _this.selectedShipRefs = [];
    _this.location = {};
    _this.fromTrucks = [];
    _this.currentPlanId = null;
    _this.targetTruck = null;
    _this.targetPlanId = 'newPlanId';
    _this.popperOptions = {
      boundariesElement: 'body',
      gpuAcceleration: false
    };
    _this.dragOptions = {
      group: 'masterpointId',
      ghostClass: 'ghost',
      animation: 300,
      filter: '.disabled',
      onMove: function onMove(e) {
        return !e.related.classList.contains('disabled');
      }
    };
    _this.routeIndex = null;
    _this.latestStartTime = null;
    _this.isLoading = false;
    return _this;
  }

  (0, _createClass2.default)(LMDTransferOrderModalComponent, [{
    key: "onVisibilityChanges",
    value: function onVisibilityChanges(newVal) {
      this.openMapModal = newVal;
    }
  }, {
    key: "onRoutesChange",
    value: function onRoutesChange(newVal) {
      this.initMap(newVal);
    }
  }, {
    key: "onSelectedTruckChange",
    value: function onSelectedTruckChange(newVal) {
      this.fromTrucks = [this.$selectedTruck];
      var truckData = this.getRoutes(newVal);
      this.initMap(truckData);
    } // duplicated

  }, {
    key: "isChina",
    get: function get() {
      return this.$userSetting['default10'];
    }
  }, {
    key: "isDragRouteDisabled",
    get: function get() {
      var hasLockedOrCompletedRoute = this.helper.some(this.mapPoints, function (route) {
        return route.locked || route.status.toUpperCase() === 'COMPLETED';
      });
      return this.fromTrucks.length > 1 || hasLockedOrCompletedRoute || !this.currentPlanId;
    }
  }, {
    key: "isRemoveOrdersDisabled",
    get: function get() {
      return this.isAutoAssign || this.$anyChanges || this.selectedShipRefs.length === 0 || this.areSomeRoutesStatusCompleted || this.hasCompletedWaypoint;
    }
  }, {
    key: "isTransferLoadPlanDisabled",
    get: function get() {
      return this.isAutoAssign || this.$anyChanges || this.selectedShipRefs.length === 0 || this.fromTrucks.length === 0 || !this.targetTruck || !this.targetPlanId || this.areSomeRoutesStatusCompleted || this.hasCompletedWaypoint || this.isTargetTruckRoutesAssignedCompleted;
    }
  }, {
    key: "areSomeRoutesStatusCompleted",
    get: function get() {
      var _this2 = this;

      var areSomeStatusCompleted = false;
      var filteredTrucks = this.$plan.trucks.filter(function (truck) {
        return _this2.fromTrucks.includes(truck.truckId);
      });
      this.helper.forEach(filteredTrucks, function (truck) {
        var bool = _this2.helper.some(truck.routes, function (r) {
          var intersect = _this2.helper.intersection(r.shipmentReference, _this2.selectedShipRefs);

          if (intersect.length > 0 && (r.status.toUpperCase() === 'ARRIVED' || r.status.toUpperCase() === 'ASSIGNED' || r.status.toUpperCase() === 'COMPLETED')) {
            areSomeStatusCompleted = true;
            return true;
          } else {
            return false;
          }
        }); // break


        if (bool) {
          return false;
        }
      });
      return areSomeStatusCompleted;
    }
  }, {
    key: "hasCompletedWaypoint",
    get: function get() {
      var _this3 = this;

      var hasCompletedWaypoint = false;
      var unassignedOrders = this.$plan.orders.filter(function (i) {
        return _this3.selectedShipRefs.includes(i.shipmentReference);
      });
      this.helper.forEach(unassignedOrders, function (order) {
        if (_this3.helper.some(order['waypoints'], function (i) {
          return i['completedTime'] !== '0000-00-00 00:00:00' && i['completedTime'] !== null;
        })) {
          hasCompletedWaypoint = true;
          return false;
        }
      });
      return hasCompletedWaypoint;
    }
  }, {
    key: "isTargetTruckRoutesAssignedCompleted",
    get: function get() {
      var _this4 = this;

      var routes = this.getRoutes(this.targetTruck).filter(function (i) {
        return i['planId'] === _this4.targetPlanId;
      }) || [];
      var filteredRoutes = routes.find(function (tData) {
        return tData['status'].toUpperCase() === 'ASSIGNED' || tData['status'].toUpperCase() === 'ARRIVED' || tData['status'].toUpperCase() === 'COMPLETED';
      });
      return this.targetTruck && this.targetPlanId && routes.length > 0 && !this.helper.isEmptyObject(filteredRoutes);
    }
  }, {
    key: "fromPlanIds",
    get: function get() {
      if (this.fromTrucks.length) {
        return this.helper.uniq(this.mapPoints.filter(function (i) {
          return i.isFrom;
        }).map(function (i) {
          return i.planId;
        }));
      }

      return [];
    }
  }, {
    key: "truckIds",
    get: function get() {
      var trucks = this.helper.get(this.$plan, 'trucks', []);
      return trucks.length === 0 ? [] : trucks.map(function (i) {
        return i.truckId;
      });
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "clearSelectedTrucks",
    value: function clearSelectedTrucks() {
      this.$emit('modalClose');
      this.openMapModal = false;
      this.selectedShipRefs = [];
      this.currentPlanId = null;
      this.targetTruck = null;
      this.targetPlanId = 'newPlanId';
    }
  }, {
    key: "isRouteFiltered",
    value: function isRouteFiltered(route) {
      var isPlanIdSame = route.planId === this.currentPlanId;
      var isPlanIdExists = this.truckPlanIds.length > 0 && !this.helper.isUndefined(this.currentPlanId);
      return isPlanIdSame && isPlanIdExists;
    }
  }, {
    key: "isRouteDisabled",
    value: function isRouteDisabled(route) {
      return route.locked || route.status.toUpperCase() === 'COMPLETED';
    }
  }, {
    key: "isRouteLast",
    value: function isRouteLast(route, points) {
      if (this.helper.isUndefined(route) || points.length === 0) {
        return false;
      }

      var isRouteLast = false;
      var routeIndex = this.helper.findIndex(points, function (i) {
        return i.code === route.code && i.orderId.toString() === route.orderId.toString();
      });

      if (routeIndex === -1) {
        return false;
      }

      if (routeIndex === points.length - 1) {
        isRouteLast = true;
      } else if (routeIndex !== 0) {
        isRouteLast = route.planId === points[routeIndex - 1].planId && route.planId !== points[routeIndex + 1].planId;
      }

      return isRouteLast;
    }
  }, {
    key: "getRouteIndex",
    value: function getRouteIndex(route) {
      var isFrom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var points = this.mapPoints.filter(function (r) {
        return r.isFrom === isFrom;
      });
      var routeIndex = this.helper.findIndex(points, function (i) {
        return i.code === route.code && i.orderId.toString() === route.orderId.toString();
      });
      return isFrom ? routeIndex + 1 : routeIndex + 1 + this.mapPoints.filter(function (r) {
        return r.isFrom;
      }).length;
    }
  }, {
    key: "getRouteStyles",
    value: function getRouteStyles(route) {
      var cursorStyle = this.isPlanIdBelongToDifferentUser(this.currentPlanId) || this.isDragRouteDisabled ? 'initial' : 'move';
      return {
        cursor: cursorStyle
      };
    }
  }, {
    key: "getRouteClass",
    value: function getRouteClass(route, routeIndex) {
      var fromPoints = this.mapPoints.filter(function (r) {
        return r.isFrom;
      });
      var intersect = this.helper.intersection(route.shipmentReference, this.selectedShipRefs);
      return (0, _defineProperty2.default)({
        'last-child': this.isRouteLast(route, fromPoints),
        disabled: this.isRouteDisabled(route),
        selected: intersect.length > 0
      }, route.status, true);
    }
  }, {
    key: "getTargetRouteStyles",
    value: function getTargetRouteStyles(route) {
      return {
        cursor: 'initial'
      };
    }
  }, {
    key: "getTargetRouteClass",
    value: function getTargetRouteClass(route) {
      var toPoints = this.mapPoints.filter(function (r) {
        return !r.isFrom;
      });
      return (0, _defineProperty2.default)({
        'last-child': this.isRouteLast(route, toPoints),
        disabled: this.isRouteDisabled(route)
      }, route.status, true);
    }
  }, {
    key: "getOrderId",
    value: function getOrderId(route) {
      return parseInt(route.masterpointId.split('-')[0], 10) || null;
    }
  }, {
    key: "getStartAndEndTime",
    value: function getStartAndEndTime() {
      var waypointIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (waypointIds.length >= 1) {
        var startTime = this.getWaypointFromId(waypointIds[0], 'startTime');
        var endTime = this.getWaypointFromId(waypointIds[0], 'endTime');
        var stTime = startTime && startTime.split(' ').length === 2 ? startTime.split(' ')[1] : '00:00:00';
        var etTime = endTime && endTime.split(' ').length === 2 ? endTime.split(' ')[1] : '23:59:00';
        return "".concat(stTime.substring(0, 5), " - ").concat(etTime.substring(0, 5));
      }

      return '00:00 - 23:59';
    }
  }, {
    key: "isRouteLate",
    value: function isRouteLate(route) {
      var runningTime = route.runningTime ? Number(route.runningTime) : 0;
      var timeWindow = route.timeWindow.length === 2 ? route.timeWindow : [0, 0];
      var bool1 = runningTime >= Number(timeWindow[0]) && runningTime <= Number(timeWindow[1]);
      return !bool1 || this.isRouteEarlyLate(route) ? 'route-late' : '';
    }
  }, {
    key: "isRouteEarlyLate",
    value: function isRouteEarlyLate(route) {
      var orderId = parseInt(route.masterpointId.split('-')[0], 10) || null;
      var waypointIndex = parseInt(route.masterpointId.split('-')[1], 10) || null;
      var eta = route.estimateTime;

      if (orderId && waypointIndex) {
        var order = this.$plan['orders'].filter(function (o) {
          return o['id'] === orderId;
        });

        if (!order || order.length === 0) {
          return '';
        }

        var waypoint = order[0].waypoints[waypointIndex - 1];

        if (!waypoint || waypoint.length === 0) {
          return '';
        }

        var startDuration = _moment.default.duration(route.timeWindow[0], 'seconds').as('milliseconds');

        var startTime = _moment.default.utc(startDuration).format('HH:mm:ss');

        startTime = (0, _moment.default)(waypoint.startTime).format("YYYY-MM-DD ".concat(startTime));

        var endDuration = _moment.default.duration(route.timeWindow[1], 'seconds').as('milliseconds');

        var endTime = _moment.default.utc(endDuration).format('HH:mm:ss');

        endTime = (0, _moment.default)(waypoint.startTime).format("YYYY-MM-DD ".concat(endTime));

        if (endTime.substring(11, 19) === '00:00:00') {
          endTime = (0, _moment.default)(endTime).format('YYYY-MM-DD 23:59:59');
        }

        return (0, _moment.default)(eta).diff(endTime) > 0 || (0, _moment.default)(eta).diff(startTime) < 0;
      }

      return false;
    }
  }, {
    key: "handleSelectShipRef",
    value: function () {
      var _handleSelectShipRef = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(shipRef) {
        var isExist;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isExist = this.selectedShipRefs.indexOf(shipRef);

                if (this.selectedShipRefs.length === 0 || isExist === -1) {
                  this.selectedShipRefs.push(shipRef);
                } else {
                  this.selectedShipRefs = this.selectedShipRefs.filter(function (i) {
                    return i !== shipRef;
                  });
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSelectShipRef(_x) {
        return _handleSelectShipRef.apply(this, arguments);
      }

      return handleSelectShipRef;
    }()
  }, {
    key: "transferOrder",
    value: function () {
      var _transferOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this5 = this;

        var unassignedOrders, targetTruckObj, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.isLoading = true;

                if (!this.isTransferLoadPlanDisabled) {
                  _context2.next = 4;
                  break;
                }

                this.isLoading = false;
                return _context2.abrupt("return");

              case 4:
                unassignedOrders = this.$plan.orders.filter(function (i) {
                  return _this5.selectedShipRefs.includes(i.shipmentReference);
                });
                targetTruckObj = this.getTruckInPlan(this.targetTruck);

                if (targetTruckObj) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 9;
                return this.assignOrderToTruck({
                  unassignedOrders: unassignedOrders,
                  isEmptyTruck: true
                });

              case 9:
                res = _context2.sent;
                _context2.next = 15;
                break;

              case 12:
                _context2.next = 14;
                return this.assignOrderToTruck({
                  unassignedOrders: unassignedOrders,
                  isEmptyTruck: false
                });

              case 14:
                res = _context2.sent;

              case 15:
                if (res) {
                  _context2.next = 18;
                  break;
                }

                this.isLoading = false;
                return _context2.abrupt("return");

              case 18:
                _context2.next = 20;
                return this.updateAffectedTruckData();

              case 20:
                this.fromTrucks = this.fromTrucks.filter(function (i) {
                  return _this5.truckIds.includes(i);
                });
                this.logger.info('Transfer Order', {
                  selectedShipRefs: this.selectedShipRefs,
                  unassignedOrders: unassignedOrders,
                  targetTruck: this.targetTruck,
                  plan: this.$plan
                });
                this.isLoading = false;

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function transferOrder() {
        return _transferOrder.apply(this, arguments);
      }

      return transferOrder;
    }()
  }, {
    key: "assignOrderToTruck",
    value: function () {
      var _assignOrderToTruck = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3) {
        var unassignedOrders, isEmptyTruck, res, isNewPlanId, planId, prefix, newPlanIds, truckObj;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                unassignedOrders = _ref3.unassignedOrders, isEmptyTruck = _ref3.isEmptyTruck;
                isNewPlanId = this.targetPlanId === 'newPlanId';
                planId = this.targetPlanId;

                if (!isNewPlanId) {
                  _context3.next = 9;
                  break;
                }

                prefix = this.helper.generateNewPlanId(this.$userData.planIdFormat, this.$planDate, this.$userInformation, 'lastmile');
                _context3.next = 7;
                return this.routeAPI.generateLoadPlanId(prefix, 1);

              case 7:
                newPlanIds = _context3.sent;
                planId = this.helper.get(newPlanIds, 'data.0', []);

              case 9:
                if (!isEmptyTruck) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 12;
                return this.handleNewTruckObj({
                  planId: planId,
                  truckId: this.targetTruck,
                  unassignedOrders: unassignedOrders,
                  isTransfer: true
                });

              case 12:
                res = _context3.sent;
                _context3.next = 19;
                break;

              case 15:
                truckObj = this.getTruckInPlan(this.targetTruck);
                _context3.next = 18;
                return this.handleExistingTruckObj({
                  planId: planId,
                  isNewPlanId: isNewPlanId,
                  truckObj: truckObj,
                  unassignedOrders: unassignedOrders,
                  isTransfer: true
                });

              case 18:
                res = _context3.sent;

              case 19:
                if (!this.helper.isUndefined(res)) {
                  _context3.next = 22;
                  break;
                }

                this.isManualAssignLoading = false;
                return _context3.abrupt("return", false);

              case 22:
                this.$failedOrders = this.helper.get(res, 'failedOrders', []);
                this.$anyChanges = true;
                this.isManualAssignLoading = false;
                return _context3.abrupt("return", true);

              case 26:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function assignOrderToTruck(_x2) {
        return _assignOrderToTruck.apply(this, arguments);
      }

      return assignOrderToTruck;
    }()
  }, {
    key: "updateAffectedTruckData",
    value: function () {
      var _updateAffectedTruckData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this6 = this;

        var bufferPlan, selectedOrderIds, payload, res, data, message;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                bufferPlan = this.helper.cloneDeep(this.$plan);
                selectedOrderIds = bufferPlan.orders.filter(function (i) {
                  return _this6.selectedShipRefs.includes(i.shipmentReference);
                }).map(function (i) {
                  return i.id;
                });
                payload = {
                  code: this.$planDate,
                  vehicleFrom: [],
                  vehicleTo: this.getTruckInPlan(this.targetTruck)
                };
                this.fromTrucks.forEach(function (truckId) {
                  var truckObj = _this6.getTruckInPlan(truckId);

                  var orderId = truckObj['orderId'].filter(function (i) {
                    return !selectedOrderIds.includes(i);
                  });
                  payload.vehicleFrom.push({
                    truckId: truckId,
                    orderId: orderId
                  });
                });
                _context4.next = 6;
                return this.lastMileDeliveryAPI.transferPlan(payload);

              case 6:
                res = _context4.sent;
                data = this.helper.get(res, 'data', null);
                message = {
                  title: this.$i18n.t('planning.messages.transferSuccess'),
                  duration: 5000
                };

                if (data) {
                  _context4.next = 13;
                  break;
                }

                message['title'] = this.$i18n.t('planning.messages.transferFailed');

                _elementUi.Notification.error(message);

                return _context4.abrupt("return", false);

              case 13:
                bufferPlan['planId'] = data['planId'];
                bufferPlan['truckId'] = data['truckId'];
                bufferPlan['trucks'] = data['data'];

                _elementUi.Notification.success(message);

                this.$setPlan({
                  'plan': bufferPlan
                });
                this.resetData();

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateAffectedTruckData() {
        return _updateAffectedTruckData.apply(this, arguments);
      }

      return updateAffectedTruckData;
    }()
  }, {
    key: "resetData",
    value: function resetData() {
      /*this.$emit('modalClose');
      this.openMapModal = false;*/
      this.selectedShipRefs = [];
      /*this.$selectedTruck = this.targetTruck;
      this.fromTrucks = [ this.$selectedTruck ];
           // Socket for global trucks
      this.socketAPI.updateLMDGlobalSelectedTrucks({
        userEmail: this.$userInformation.user.name,
        socketId: this.$socketId,
        truckId: this.$selectedTruck ? [this.$selectedTruck] : [],
      });*/

      this.currentPlanId = null;
      this.targetTruck = null;
      this.targetPlanId = 'newPlanId';
      this.initMapPoints(); // this.refreshMap();
    }
  }, {
    key: "getUsername",
    value: function getUsername() {
      var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.routes;
      var planId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currentPlanId;
      return this.helper.get(routes.filter(function (r) {
        return r['planId'] === planId;
      }), '0.user', this.$userInformation.user.name);
    }
  }, {
    key: "handleTargetTruckChange",
    value: function handleTargetTruckChange(newVal) {
      var fromPoints = this.mapPoints.filter(function (r) {
        return r.isFrom;
      });
      var toPoints = this.targetTruck ? this.getRoutes(this.targetTruck) : [];
      this.mapPoints = [].concat((0, _toConsumableArray2.default)(fromPoints), (0, _toConsumableArray2.default)(toPoints.map(function (r) {
        return _objectSpread(_objectSpread({}, r), {}, {
          isFrom: false
        });
      })));
      this.refreshMap(); // Socket for global trucks

      this.socketAPI.updateLMDGlobalSelectedTrucks({
        userEmail: this.$userInformation.user.name,
        socketId: this.$socketId,
        truckId: [].concat((0, _toConsumableArray2.default)(this.fromTrucks), [newVal])
      });
    }
  }, {
    key: "handleFromTrucksChange",
    value: function handleFromTrucksChange(newVal) {
      var _this7 = this;

      var fromPoints = [];
      var toPoints = this.mapPoints.filter(function (r) {
        return !r.isFrom;
      });
      newVal.forEach(function (truckId) {
        fromPoints.push.apply(fromPoints, (0, _toConsumableArray2.default)(_this7.getRoutes(truckId)));
      });
      this.mapPoints = [].concat((0, _toConsumableArray2.default)(fromPoints.map(function (r) {
        return _objectSpread(_objectSpread({}, r), {}, {
          isFrom: true
        });
      })), (0, _toConsumableArray2.default)(toPoints));
      this.refreshMap();
      this.selectedShipRefs = []; // Socket for global trucks

      this.socketAPI.updateLMDGlobalSelectedTrucks({
        userEmail: this.$userInformation.user.name,
        socketId: this.$socketId,
        truckId: [].concat((0, _toConsumableArray2.default)(newVal), [this.targetTruck])
      });
    }
  }, {
    key: "refreshMap",
    value: function refreshMap() {
      if (this.$refs.mapWorld) {
        this.$refs.mapWorld.refreshMap(this.mapPoints, {
          planId: this.currentPlanId
        });
      }
    }
  }, {
    key: "redrawMarkerOnly",
    value: function redrawMarkerOnly() {
      if (this.$refs.mapWorld) {
        this.$refs.mapWorld.clearMarker();
        this.$refs.mapWorld.initPolyline(this.mapPoints, this.currentPlanId, true);
      }
    }
  }, {
    key: "initMapPoints",
    value: function initMapPoints() {
      this.mapPoints = (0, _toConsumableArray2.default)(this.getRoutes(this.$selectedTruck)).map(function (r) {
        return _objectSpread(_objectSpread({}, r), {}, {
          isFrom: true
        });
      });
    }
  }, {
    key: "initMap",
    value: function initMap(truckData) {
      if (truckData[0] && truckData[0]['latitude'] && truckData[0]['longitude']) {
        this.location = {
          latitude: Number(truckData[0]['latitude']),
          longitude: Number(truckData[0]['longitude'])
        };
      }

      this.initMapPoints();
      this.refreshMap();
    }
  }, {
    key: "isNotToTrucks",
    value: function isNotToTrucks(truckId) {
      return this.targetTruck ? truckId !== this.targetTruck : true;
    }
  }, {
    key: "removeOrders",
    value: function () {
      var _removeOrders = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this8 = this;

        var payload, filteredTrucks, res, data, message, bufferPlan, selectedOrders, dOrders, dOrderIds;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.isRemoveOrdersDisabled) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                payload = {
                  code: this.$planDate,
                  vehicle: []
                };
                filteredTrucks = this.$plan.trucks.filter(function (truck) {
                  return _this8.fromTrucks.includes(truck.truckId);
                });
                filteredTrucks.forEach(function (truck) {
                  var bool = _this8.helper.some(truck.routes, function (r) {
                    var intersect = _this8.helper.intersection(r.shipmentReference, _this8.selectedShipRefs);

                    return intersect.length > 0;
                  });

                  if (bool) {
                    var truckShipRefs = _this8.helper.uniq(_this8.helper.flatten(truck.routes.map(function (r) {
                      return r.shipmentReference;
                    })));

                    var deletedShipRef = _this8.helper.intersection(truckShipRefs, _this8.selectedShipRefs);

                    var deletedOrders = _this8.$plan.orders.filter(function (o) {
                      return deletedShipRef.includes(o.shipmentReference);
                    });

                    var deletedOrderIds = deletedOrders.map(function (o) {
                      return o.id;
                    });
                    payload.vehicle.push({
                      truckId: truck.truckId,
                      orderId: deletedOrderIds
                    });
                  }
                });
                _context5.next = 7;
                return this.lastMileDeliveryAPI.removeOrder(payload);

              case 7:
                res = _context5.sent;
                data = this.helper.get(res, 'data', null);
                message = {
                  title: this.$i18n.t('planning.messages.unassignSuccess'),
                  duration: 5000
                };

                if (data) {
                  _context5.next = 14;
                  break;
                }

                message['title'] = this.$i18n.t('planning.messages.unassignFailed');

                _elementUi.Notification.error(message);

                return _context5.abrupt("return", false);

              case 14:
                bufferPlan = this.helper.cloneDeep(this.$plan);
                selectedOrders = bufferPlan['orders'].filter(function (o) {
                  return !_this8.selectedShipRefs.includes(o.shipmentReference);
                });
                dOrders = bufferPlan['orders'].filter(function (o) {
                  return _this8.selectedShipRefs.includes(o.shipmentReference);
                });
                dOrderIds = dOrders.map(function (o) {
                  return o.id;
                });
                bufferPlan['orderId'] = data['orderId'];
                bufferPlan['orders'] = selectedOrders;
                bufferPlan['planId'] = data['planId'];
                bufferPlan['truckId'] = data['truckId'];
                bufferPlan['trucks'] = data['data'];
                bufferPlan['updatedAt'] = data['updatedAt'];
                bufferPlan['updatedUser'] = data['updatedUser'];
                this.$includedOrders = [].concat((0, _toConsumableArray2.default)(this.$includedOrders), (0, _toConsumableArray2.default)(dOrderIds));
                _context5.next = 28;
                return this.$getUnassignedOrders();

              case 28:
                this.$anyChanges = true;

                _elementUi.Notification.success(message);

                this.$setPlan({
                  'plan': bufferPlan
                });
                this.resetData();

              case 32:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function removeOrders() {
        return _removeOrders.apply(this, arguments);
      }

      return removeOrders;
    }()
  }, {
    key: "handleRouteDrag",
    value: function () {
      var _handleRouteDrag = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(e) {
        var oldIndex, newIndex;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                oldIndex = e.moved.oldIndex;
                newIndex = e.moved.newIndex;
                this.routeIndex = newIndex < oldIndex ? newIndex : oldIndex;
                _context6.next = 5;
                return this.updateETA();

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function handleRouteDrag(_x3) {
        return _handleRouteDrag.apply(this, arguments);
      }

      return handleRouteDrag;
    }()
  }, {
    key: "updateETA",
    value: function () {
      var _updateETA = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _this9 = this;

        var payload, calculateEta;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                payload = {
                  routes: this.helper.cloneDeep(this.mapPoints.filter(function (i) {
                    return i.planId === _this9.currentPlanId;
                  })),
                  startTime: null,
                  index: this.routeIndex >= 1 ? this.routeIndex - 1 : this.routeIndex
                };
                _context7.next = 3;
                return this.calculateETA(payload, 'REORDER');

              case 3:
                calculateEta = _context7.sent;

                if (calculateEta) {
                  this.updateCurrentTruck(calculateEta);
                }

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function updateETA() {
        return _updateETA.apply(this, arguments);
      }

      return updateETA;
    }()
  }, {
    key: "drawPolygon",
    value: function drawPolygon() {
      this.selectedShipRefs = [];

      if (this.$refs.mapWorld) {
        this.$refs.mapWorld.drawPolygonTransferPlan('#fde85d');
      }
    }
  }, {
    key: "handlePolygonComplete",
    value: function handlePolygonComplete(shipRefs) {
      this.selectedShipRefs = (0, _toConsumableArray2.default)(shipRefs);
    }
  }, {
    key: "saveTransferredPlan",
    value: function saveTransferredPlan() {
      this.savePlan(this.$plan, this.isAutoAssign);
      this.$emit('modalClose');
    }
  }]);
  return LMDTransferOrderModalComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileDelivery.LastMileDeliveryMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], LMDTransferOrderModalComponent.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDTransferOrderModalComponent.prototype, "isAutoAssign", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDTransferOrderModalComponent.prototype, "isVisible", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isVisible', {
  immediate: true
})], LMDTransferOrderModalComponent.prototype, "onVisibilityChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('routes', {
  deep: true
})], LMDTransferOrderModalComponent.prototype, "onRoutesChange", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$selectedTruck')], LMDTransferOrderModalComponent.prototype, "onSelectedTruckChange", null);
LMDTransferOrderModalComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDTransferOrderModalComponent',
  components: {
    'map-china': _mapChina.default,
    'map-world': _mapWorld.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-button': _elementUi.Button,
    'el-dialog': _elementUi.Dialog,
    'el-tooltip': _elementUi.Tooltip,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'draggable': _vuedraggable.default
  }
})], LMDTransferOrderModalComponent);
var _default = LMDTransferOrderModalComponent;
exports.default = _default;